import Thumbnail from "@marginly/ui/components/thumbnail";
import React, { MouseEvent } from "react";

import { T } from "@/app/client";
import Portal from "@/components/common/portal";
import Space from "@/components/common/space";

import { AlertIcon } from "../../../icons/alert-icon";
import * as S from "./styled";
interface Props {
  leverage: number;
  onCancel?: () => void;
  children: React.ReactNode;
}

export function LeverageAlertModal({ children, leverage, onCancel }: Props) {
  return (
    <Portal>
      <S.Wrapper onClick={onCancel}>
        <S.Inner onClick={(e: MouseEvent) => e.stopPropagation()}>
          <S.LiquidityThumbnailWrapper>
            <Thumbnail xl>
              <AlertIcon />
            </Thumbnail>
          </S.LiquidityThumbnailWrapper>
          <Space height={40} heightMobile={40} />
          <T headerM>Close to the margin call</T>
          <Space height={8} heightMobile={8} />
          <T>
            To avoid instant liquidation decrease the leverage to at least{" "}
            {leverage}×.
          </T>
          <Space height={32} heightMobile={32} />
          {children}
        </S.Inner>
      </S.Wrapper>
    </Portal>
  );
}
